import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-module-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing-module-card.component.html',
  styleUrl: './landing-module-card.component.scss',
})
export class LandingModuleCardComponent {
  @Input() data: any;

  constructor(private router: Router) {}

  get title(): string {
    return String(this.data?.label ?? this.data?.title ?? this.data?.name ?? '').trim();
  }

  get imageSrc(): string {
    const raw = String(this.data?.icon ?? this.data?.imagePath ?? this.data?.imageUrl ?? '').trim();
    if (!raw) return '';

    if (raw.startsWith('/') || /^https?:\/\//i.test(raw) || raw.startsWith('data:')) {
      return raw;
    }
    if (raw.startsWith('./assets/')) {
      return `/${raw.substring(2)}`;
    }
    if (raw.startsWith('assets/')) {
      return `/${raw}`;
    }
    return raw;
  }

  onCardClick(): void {
    if (this.data?.disabled) return;

    const route = String(this.data?.navigateTo ?? '').trim();
    if (route) {
      this.router.navigateByUrl(route);
      return;
    }

    const externalUrl = String(this.data?.externalUrl ?? '').trim();
    if (externalUrl) {
      window.open(externalUrl, this.data?.target || '_self');
    }
  }

  onCardKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.onCardClick();
  }
}
